import { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import graphqlQueries from '../../assets/graphql-queries.json';
import applicationResources from '../../assets/application-resources.json';

const propTypes = {
  // The name of the GraphQL query to be executed
  queryName: PropTypes.string.isRequired,
  // The GraphQL variables to be used on the query
  variables: PropTypes.object,
  // Optional extra headers
  headers: PropTypes.object,
  render: PropTypes.func.isRequired,
};

class GraphQLConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null,
      isLoading: true
    };
  }

  componentDidMount() {
    this.queryResult();
  }

  queryResult() {
    const {queryName, headers, variables} = this.props;
    var options = {
      method: 'post',
      baseURL: applicationResources[process.env.NODE_ENV].graphqlURL,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      data: {
        query: graphqlQueries[queryName],
        variables
      }
    };

    axios(options)
    .then((response) => {
      const responseBody = response.data;
      const dataObj = responseBody.data;

      this.setState({
        isLoading: false,
        result: {response, dataObj}
      });
    });
  }

  render() {
    const {render} = this.props;
    const {isLoading, result} = this.state;

    return render(isLoading, result);
  }
}

GraphQLConnector.propTypes = propTypes;

export default GraphQLConnector;



// WEBPACK FOOTER //
// ./src/component/shared/graphql-connector.js